// CMPs load asynchronously; subscribe once when the API becomes available.
export function subscribeToConsent(onChange, target = window) {
    let timer = null;
    let listenerId = null;
    let disposed = false;
    let attempts = 0;

    const removeListener = () => {
        if (listenerId == null || typeof target.__tcfapi !== 'function') return;
        const id = listenerId;
        listenerId = null;
        target.__tcfapi('removeEventListener', 2, () => {}, id);
    };

    const connect = () => {
        if (disposed) return;
        timer = null;
        if (typeof target.__tcfapi !== 'function') {
            timer = target.setTimeout(connect, ++attempts < 30 ? 1000 : 5000);
            return;
        }

        try {
            target.__tcfapi('addEventListener', 2, (data, success) => {
                if (data?.listenerId != null) listenerId = data.listenerId;
                if (disposed) {
                    removeListener();
                    return;
                }
                if (!success || !data) return;
                if (data.eventStatus === 'tcloaded' || data.eventStatus === 'useractioncomplete') {
                    onChange(typeof data.tcString === 'string' ? data.tcString : '');
                }
            });
        } catch (error) {
            timer = target.setTimeout(connect, 1000);
        }
    };

    connect();
    return () => {
        disposed = true;
        if (timer != null) target.clearTimeout(timer);
        removeListener();
    };
}
